export const LOADING = "LOADING"
export const RESULT = "RESULT"

export const LIST = "LINK_LIST"
export const LINK_MERCHANT_ID = "LIST_LINK_MERCHANT_ID"
export const UNBIND_MERCHANT_ID = "LIST_UNBIND_MERCHANT_ID"